import { RichTextField, Tab, useRecordContext, type TabProps } from 'react-admin';
import { path } from '@/pages/AdverseAction/constants';
import { FCRAWorkerAdverse } from '@/types/turn-api';

const PreAdverseTab = (props: Partial<TabProps>) => {
  useRecordContext<FCRAWorkerAdverse.Details>();
  return (
    <Tab label="Pre-Adverse Notice" path="preadverse" {...props}>
      <RichTextField label="" source={path('adverse.preadverse')} />
    </Tab>
  );
};

export default PreAdverseTab;
